import { AttachmentCategory, Category } from '@core/domain/models/category.models';
import { deepClone } from '@frontend/common/utils';
import { MenuCategory, freeTextAttachments } from '@shared/header/models/category.model';
import { AttachmentsEnums } from '@shared/header/services/attachments.enums';

export class AttachmentsUtilsService {
    public static getFreeTextAttachment(category: MenuCategory): freeTextAttachments[] {
        return category.attachments?.filter(attachment => attachment.name.includes(AttachmentsEnums.MENU_LABEL_CUSTOMTEXT));
    }

    public static existsRecursiveCategoryById(categories: MenuCategory[], id: string): Category | MenuCategory {
        if (categories?.length > 0) {
            return categories.find((cat: any) => cat.id === id || cat.redirectToCategoryId === id
                || AttachmentsUtilsService.existsRecursiveCategoryById(cat.subcategories, id));
        }
        return undefined;
    }

    public static categoriesMultiColumnTransformer(categories: MenuCategory[]): MenuCategory[] {
        return categories.map((parentCategory: MenuCategory) => {
            const _parentCategory = deepClone(parentCategory);
            _parentCategory.subcategories = parentCategory.subcategories.map((category) => {
                const _category = JSON.parse(JSON.stringify(category));
                _category.subcategories = AttachmentsUtilsService.multiColumn(category.subcategories);
                return _category;
            });
            return _parentCategory;
        });
    }

    public static multiColumn(categories: MenuCategory[]): MenuCategory[][] {
        const columns: MenuCategory[][] = [];
        let column = [];
        for (let category of categories) {
            const isNewColumn = category.attachments?.find((att) => att.name === AttachmentsEnums.NEW_COLUMN);
            if (!!isNewColumn) {
                if (column.length > 0) {
                    columns.push(column);
                    column = [];
                }
            }
            column.push(category);
        }
        columns.push(column);
        return columns;
    }

    // Se utiliza un modelo MenuCategory que no contiene la propiedad attachments ¿?
    public static checkAttachmentName(category: Category | MenuCategory, attachmentKey: string): boolean {
        return category?.attachments?.find((attachment: any) => attachment.name === attachmentKey) ?? false;
    }

    public static getSubcategories(categories: MenuCategory[], categoryId: string): MenuCategory[] {
        const cat = this.findCategory(categories, categoryId);
        let subcategories = cat?.subcategories;
        if (subcategories === undefined || subcategories.length === 0) {
            subcategories = this.getSubcategories(categories, cat.parentId);
        }
        return subcategories;
    }

    public static findCategory(categories: MenuCategory[], categoryId: string): MenuCategory {
        for (let cat of categories) {
            if (cat.id === categoryId) return cat;
            const _cat = this.findCategory(cat?.subcategories ?? [], categoryId);
            if (_cat) {
                return _cat;
            }
        }
    }

    public static removeRepeatedCategories(categories): MenuCategory[] {
        return categories.reduce((accumulator, current) => {
            if (!accumulator.find((a) => a.id === current.id)) {
                accumulator.push(current);
            }
            return accumulator;
        }, []);
    }

    /**
     * Filters attachments by name and returns their IDs, sorted by order if specified.
     * @param attachments - An array of objects representing attachments.
     * @param attachmentName - A string used to filter the attachments based on their name property.
     * @param order - An optional array of strings representing the desired order of the attachments based on their IDs.
     * @returns An array of attachment IDs that match the given attachmentName and sorted according to the order if it was provided.
    */
    public static getAttachmentsIdsByOrder(attachments: AttachmentCategory[], attachmentName: string, order?: string[]) {
        const attachmentsIds = attachments?.filter((attachment: any) =>
            attachment.name.includes(attachmentName)).map((attachment) => {
            const lastIndex = attachment.name.lastIndexOf('_');
            return attachment.name.substring(lastIndex + 1);
        });

        if (order) {
            attachmentsIds?.sort((a, b) => {
                return order.indexOf(a) - order.indexOf(b);
            });
        }

        return attachmentsIds;
    }
}
